<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PyHeu9/e9781466821705_cover.jpg?1712288233291" alt="This image is the cover for the book Artistic License"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Artistic License
      </h1>
      <p class="bookDescription body article font2">
        <p>Single, thritysomething Thea traded her promising career as a photographer for the quiet countryside of the English Cotswalds.  But when she meets a promising, sexy Irish painter while vacationing in Provence, her creative spirit is unexpectedly reawakened. <br/><br/>Impressed by Rory's charm, but even more taken by his talent, Thea is determined to showcase his paintings for the art world.  Resisting his sex appeal, convincing him to forgo the London art scene, and transforming an abandoned building into a cutting-edge gallery in the less-than-hip countryside all give Thea more of a challenge than she bargained for.<br/><br/>Add to the mix a group of old friends, some reluctant teens, a passel of puppies, and a new romantic prospect or two, and Katie Fforde's latest novel delivers art, friendship, love, sex, and delicious new beginnings.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katie Fforde
      </h2>
      
      <p class="authorDescription body article"><P><B>Katie Fforde</B> is the London Times-bestselling author of <I>Second Thyme Around, Life Skills, Stately Pursuits, </I>and<I> Wild Designs.</I> She lives in Gloucestershire, England, where she is at work on her next novel.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?630ca472